export default "__VITE_ASSET__ZKgiavIU__"